function ErrorHandling(
  data,
  setErrorAPIMessage,
  setModalIsOpenError,
  errorMessage = '',
  apiName
) {
  if (data.error === 'Request failed with status code 400')
    setErrorAPIMessage('Bad server request. Please try again later.');
  else if (data.error === 'Request failed with status code 401')
    setErrorAPIMessage('Request unauthorized. Please try again later.');
  else if (data.error === 'Request failed with status code 404')
    setErrorAPIMessage(`No records found.`);
  else if (data.error === 'Request failed with status code 500')
    setErrorAPIMessage('Internal server error. Please try again later.');
  else if (data.error === 'Request failed with status code 502')
    setErrorAPIMessage('Bad Gateaway. Please try again later.');
  else if (data.error === 'Request failed with status code 503')
    setErrorAPIMessage(
      `Service temporarily unavailable for ${apiName}. Please try again later.`
    );
  else if (data.error === 'Request failed with status code 504')
    setErrorAPIMessage(
      `Gateaway time-out. ${apiName} Server error. Please try again later.`
    );
  else if (data.error === process.env.NEXT_PUBLIC_RateLimitError)
    setErrorAPIMessage(process.env.NEXT_PUBLIC_rate_limit);
  else if (data.message === 'Unauthorized') setErrorAPIMessage('Unauthorized');
  else if (data.result === 'Invalid token') setErrorAPIMessage('Invalid token');
  else {
    if (errorMessage) setErrorAPIMessage(errorMessage);
    else if (apiName) {
      setErrorAPIMessage(`Failed to load ${apiName}`);
    } else setErrorAPIMessage('Check your connection. Please try again.');
    // setErrorAPIMessage('Please try again. Error: ', data);
  }
  setModalIsOpenError(true);
}

export default ErrorHandling;

// /503,504
